import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard, Package, Users, Tag, DoorOpen,
  BarChart3, UserCog, LogOut, Settings, Radio, LayoutGrid, Monitor
} from 'lucide-react';

const allNav = [
  { path: '/panel', label: 'Panel', icon: LayoutDashboard, roles: ['admin', 'cajero', 'mesero'] },
  { path: '/pos', label: 'POS Tactil', icon: Monitor, roles: ['admin', 'cajero', 'mesero'] },
  { path: '/pulsera', label: 'Pulsera RFID', icon: Radio, roles: ['admin', 'cajero', 'mesero'] },
  { path: '/lockers', label: 'Mapa Lockers', icon: LayoutGrid, roles: ['admin', 'cajero', 'mesero'] },
  { path: '/visitas', label: 'Visitas', icon: DoorOpen, roles: ['admin', 'cajero', 'mesero'] },
  { path: '/productos', label: 'Productos', icon: Package, roles: ['admin'] },
  { path: '/clientes', label: 'Clientes', icon: Users, roles: ['admin', 'cajero'] },
  { path: '/precios', label: 'Precios', icon: Tag, roles: ['admin'] },
  { path: '/reportes', label: 'Reportes', icon: BarChart3, roles: ['admin', 'cajero'] },
  { path: '/personal', label: 'Personal', icon: UserCog, roles: ['admin'] },
  { path: '/configuracion', label: 'Configuracion', icon: Settings, roles: ['admin'] },
];

const roleLabels = { admin: 'Administrador', cajero: 'Cajero', mesero: 'Mesero' };

export default function Sidebar({ onNavigate }) {
  const { user, logout } = useAuth();
  const navItems = allNav.filter(n => n.roles.includes(user?.role));

  return (
    <div className="flex flex-col h-full">
      <div className="p-6 pb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-orange-700 rounded-xl flex items-center justify-center flex-shrink-0">
            <span className="text-white font-outfit font-bold text-sm">CS</span>
          </div>
          <div>
            <h2 className="font-outfit text-lg font-semibold text-stone-900 leading-tight">Club Sauna</h2>
            <p className="text-xs text-stone-500">Administracion</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 space-y-1">
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onNavigate}
            data-testid={`nav-${item.path.slice(1)}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                isActive
                  ? 'bg-orange-700 text-white shadow-sm'
                  : 'text-stone-600 hover:bg-stone-100 hover:text-stone-900'
              }`
            }
          >
            <item.icon className="w-4 h-4" strokeWidth={1.5} />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-stone-200">
        <div className="flex items-center gap-3 px-2 mb-3">
          <div className="w-8 h-8 bg-stone-200 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-stone-600 text-xs font-semibold">{user?.name?.charAt(0)?.toUpperCase()}</span>
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-stone-900 truncate">{user?.name}</p>
            <p className="text-xs text-stone-500">{roleLabels[user?.role] || user?.role}</p>
          </div>
        </div>
        <button
          data-testid="logout-btn"
          onClick={logout}
          className="flex items-center gap-2 w-full px-4 py-2 rounded-xl text-sm font-medium text-stone-600 hover:bg-red-50 hover:text-red-700 transition-all"
        >
          <LogOut className="w-4 h-4" strokeWidth={1.5} />
          Cerrar sesion
        </button>
      </div>
    </div>
  );
}
